export const SET_PROGRESS_VALUE = 'setProgressValue'
export const SET_SEARCHING_STATUS = 'setSearchingStatus'
export const SET_ORGANIZATION_BY_INDEX = 'setOrganizationByIndex'
export const SET_TITLE_BY_INDEX = 'setTitleByIndex'
export const SET_GROUP_BY_INDEX = 'setGroupByIndex'
export const SET_CONTACT_SELECTED_BY_INDEX = 'setContactSelectedByIndex'
export const SET_CATEGORY_BY_INDEX = 'setCategoryByIndex'
export const SET_DESCRIPTION_BY_INDEX = 'setDescriptionByIndex'
export const SET_PENDING_STATUS_CODE_BY_INDEX = 'setPendingStatusCodeByIndex'
export const UPDATE_CONTACTS_PENDING_STATUS_CODE = 'updateContactsPendingStatusCode'
export const UPDATE_CONTACT_MESSAGE = 'updateContactMessage'
export const ARCHIVE_CONTACT_BY_INDEX = 'setHasInboxByIndex'
export const SET_HASUNREAD_BY_INDEX = 'setHasUnreadByIndex'
export const SET_QUERYING_UPDATE_NEW_CONTACT = 'setQueryingUpdateNewContact'
export const SET_QUERY_UPDATE_NEW_CONTACT_DISABLED = 'setQueryUpdateNewContactDisabled'
export const SET_QUERY_COUNT = 'setQueryCount'
export const INIT_SEARCH = 'initSearch'
export const CLEAR_SEARCH = 'clearSearch'
